const A2B = () => {
  return (
    <svg
      width="56"
      height="40"
      viewBox="0 0 26 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.545 2.444C6.144 2.444 5.818 2.121 5.818 1.722C5.818 1.323 6.144 1 6.545 1H12.364C14.372 1 16 2.617 16 4.611C16 6.605 14.372 8.222 12.364 8.222H3.636C2.431 8.222 1.455 9.192 1.455 10.389C1.455 11.586 2.431 12.556 3.636 12.556H9.455C9.856 12.556 10.182 12.879 10.182 13.278C10.182 13.677 9.856 14 9.455 14H3.636C1.628 14 0 12.383 0 10.389C0 8.395 1.628 6.778 3.636 6.778H12.364C13.569 6.778 14.545 5.808 14.545 4.611C14.545 3.414 13.569 2.444 12.364 2.444H6.545Z"
        fill="#1F1F68"
      />
      <path
        d="M2.182 4.364C0.977 4.364 0 3.387 0 2.182C0 0.977 0.977 0 2.182 0C3.387 0 4.364 0.977 4.364 2.182C4.364 3.387 3.387 4.364 2.182 4.364ZM2.182 2.909C2.583 2.909 2.909 2.583 2.909 2.182C2.909 1.78 2.583 1.455 2.182 1.455C1.78 1.455 1.455 1.78 1.455 2.182C1.455 2.583 1.78 2.909 2.182 2.909ZM13.818 16C12.613 16 11.636 15.023 11.636 13.818C11.636 12.613 12.613 11.636 13.818 11.636C15.023 11.636 16 12.613 16 13.818C16 15.023 15.023 16 13.818 16ZM13.818 14.545C14.22 14.545 14.545 14.22 14.545 13.818C14.545 13.417 14.22 13.091 13.818 13.091C13.417 13.091 13.091 13.417 13.091 13.818C13.091 14.22 13.417 14.545 13.818 14.545Z"
        fill="#1F1F68"
        fillOpacity="0.5"
      />
    </svg>
  )
}

export default A2B
